import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import adminApi from '../../APIs/admin';
import {
  PageHeader,
  Pagination,
  Table,
  Typography,
} from '../../designComponents';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import { requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { ParamsType } from '../CreateJobs/CreateNewJobs/type';
import { TechnicianStyled } from './style';
import { getTableData } from './userTableData';

const Technicians = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const technicians = useSelector((state: RootState) => state.clientData.data);
  const pagination = useSelector(
    (state: RootState) => state.clientData.pagination,
  );

  const getTechnicians = async (pageParams: MyParamsType) => {
    try {
      await requestAPI(
        adminApi.getUserByRole({
          page: pageParams.page,
          limit: pageParams.limit,
          search: pageParams.search ? pageParams.search : '',
          role: 'TECHNICIAN',
        }),
      );
    } catch (error: any) {
      console.error(error);
      toast.error(error);
    }
  };
  const debouncedFunction = useCallback(
    debounce((myParams) => getTechnicians(myParams), 500),
    [],
  );
  useEffect(() => {
    getTechnicians(pagination);
  }, []);

  const handlePagination = (updatedParams: ParamsType) => {
    getTechnicians(updatedParams);
    dispatch(Store.Actions.update('clientData.pagination', updatedParams));
  };

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };
  return (
    <TechnicianStyled>
      <PageHeader
        pageTitle={
          <Typography strong variant="title">
            Technicians
          </Typography>
        }
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />
      <div className="table-container">
        <Table tableData={getTableData(navigate, technicians)} />
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </TechnicianStyled>
  );
};

export default Technicians;
